/**
 * Converts number to float.
 */
export function toFloat(val: number) {
  return parseFloat(`${val}`) || 0;
}
